import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "@dbeining/react-atom";
import { invitationService, authenticationService } from "../../services";
import { userAtom } from "../../atoms/userAtom";
import { IInviteAcceptance } from "../../customTypings/user/InviteAcceptance";

export const useInvitationLogic = (id: string) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [inviteAcceptance, setInviteAcceptance] = useState<IInviteAcceptance | null>(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [showLogout, setShowLogout] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [email, setEmail] = useState("");
    const currentUser = useAtom(userAtom);

    useEffect(() => {
        setIsLoading(true);
        setShowLogout(false);
        
        invitationService.exists(id).then(
            () => {
                if (currentUser) {
                    invitationService
                        .checkIsForEmail(id, currentUser.identity.email)
                        .then(
                            (response) => {
                                if (response.status !== "Failure") {
                                    navigate("/invitations", { replace: true });
                                } else {
                                    setErrorMessage(response.message);
                                }
                            },
                            (error) => {
                                if (error.status === 400) {
                                    setErrorMessage("Not a valid invitation.");
                                } else {
                                    setErrorMessage(error);
                                    setShowLogout(true);
                                }
                            }
                        );
                } else {
                    invitationService.getEmailIfAccountExists(id).then(
                        (response) => {
                            if (response.status === 0) {
                                setEmail(response.email);
                                setShowLogin(true);
                            } else {
                                invitationService.getById(id).then(
                                    (inviteAcceptance) => {
                                        setInviteAcceptance(inviteAcceptance);
                                    },
                                    (error) => {
                                        if (error.status === 400) {
                                            setErrorMessage("Not a valid invitation.");
                                        } else {
                                            setErrorMessage(error);
                                        }
                                    }
                                );
                            }
                        },
                        (error) => {
                            if (error.status === 400) {
                                setErrorMessage("Not a valid invitation.");
                            } else {
                                setErrorMessage(error);
                            }
                            setErrorMessage(error);
                        }
                    );
                }
            },
            (error) => {
                if (error.status === 400) {
                    setErrorMessage("Not a valid invitation.");
                } else {
                    setErrorMessage(error);
                }
            }
        );
        setIsLoading(false);
    }, [id, currentUser, navigate]);

    const logout = () => {
        setIsLoading(true);
        authenticationService.logout();
    };

    return {
        isLoading,
        inviteAcceptance,
        errorMessage,
        showLogout,
        showLogin,
        email,
        logout,
        setShowLogout,
        setShowLogin
    };
};
